var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgencyaddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    rx: 5,
    fill: "#100A55"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.25 19.4266V14.2321C24.25 13.2755 24.25 12.7972 23.9905 12.4371C23.7808 12.1462 23.4444 11.9916 22.8445 11.7834C22.7218 13.2558 22.2341 14.7594 21.4684 16.0754C20.5767 17.6077 19.2527 18.9777 17.5556 19.7181C16.5665 20.1495 15.4335 20.1495 14.4444 19.7181C12.7473 18.9777 11.4233 17.6077 10.5316 16.0754C9.95079 15.0772 9.52998 13.9711 9.30707 12.8525C8.9564 12.8009 8.68729 12.8274 8.45507 12.9569C8.36241 13.0086 8.27605 13.0709 8.19771 13.1424C7.75 13.5514 7.75 14.3117 7.75 15.8323V20.3512C7.75 21.3079 7.75 21.7862 8.00954 22.1463C8.26908 22.5064 8.72285 22.6576 9.63037 22.9601L9.98197 23.0773C11.4275 23.5592 12.1503 23.8001 12.8896 23.8015C13.1123 23.8019 13.3347 23.7861 13.5551 23.7542C14.2868 23.6483 14.9742 23.3046 16.3489 22.6172C17.4024 22.0904 17.9292 21.8271 18.4888 21.7049C18.6851 21.662 18.8841 21.632 19.0844 21.6153C19.6552 21.5675 20.2311 21.6635 21.3828 21.8555L21.3828 21.8555C22.55 22.05 23.1336 22.1473 23.5597 21.9026C23.7044 21.8195 23.8328 21.7107 23.9386 21.5816C24.25 21.2016 24.25 20.6099 24.25 19.4266Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 5.83334C12.9624 5.83334 10.5 8.17278 10.5 11.0586C10.5 13.9219 12.2554 17.263 14.9942 18.4578C15.6327 18.7363 16.3673 18.7363 17.0058 18.4578C19.7446 17.263 21.5 13.9219 21.5 11.0586C21.5 8.17278 19.0376 5.83334 16 5.83334ZM16 13.1667C17.0125 13.1667 17.8333 12.3459 17.8333 11.3333C17.8333 10.3208 17.0125 9.50001 16 9.50001C14.9875 9.50001 14.1667 10.3208 14.1667 11.3333C14.1667 12.3459 14.9875 13.1667 16 13.1667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgencyaddress);
export default __webpack_public_path__ + "static/media/agencyaddress.b155ed3038ec2e5aae2cf878b7674b6b.svg";
export { ForwardRef as ReactComponent };